import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import { useParams } from "react-router-dom";
import PermissionForm from "components/Permissions/form";
import { getAllModules, getPermissionById, selectModules, selectPermission, selectPermissionsStatus, updatePermission, getAllPermissions, selectPermissions } from "redux/slices/permissionsSlice";
import { selectUser } from "redux/slices/userSlice";

const currentAction = "EDIT";
const EditPermission = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectPermissionsStatus);
  const permission = useSelector(selectPermission);
  const permissions = useSelector(selectPermissions);
  const modules = useSelector(selectModules);
  const user = useSelector(selectUser);
  const { id } = useParams();

  const canEditPermissions =
    user?.isSuperAdmin ||
    Boolean(user?.admin && import.meta.env.VITE_PERMISSION_EDITABLE_BY_ADMIN === "true");

  useEffect(() => {
    if (user && !canEditPermissions) {
      history.push(PATHS.admin.permissions);
      return;
    }
    if (id && !loading) {
      dispatch(getPermissionById(id));
      dispatch(getAllModules());
      dispatch(getAllPermissions());
    }
  }, [dispatch, id]);

  const onSubmit = async (payload) => {
    await dispatch(updatePermission(id, payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.permissions) : ""
    );
  };
  return (
    <>
      <Navbar />
      <LightLayout doublebar loading={loading || !permission}>
        <PermissionForm
          action={currentAction}
          initialValues={permission}
          onSubmit={onSubmit}
          modules={modules}
          permissions={permissions}
        />
      </LightLayout>
    </>
  );
};

export default EditPermission;
